import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Saves the project's dashboard layout (the redesigned dashboard's module
 * grid, `{ version: 1, items: [{ module, column, row }] }`). The API checks
 * PROJECT_EDIT, validates and normalizes the layout, and answers with the
 * updated project item.
 */
export const patchProjectDashboardLayout = async ({
  projectId,
  dashboardLayout,
  activeEmployerInfo = {},
}) => {
  const apiPath = `projects/${projectId}/dashboard-layout`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { dashboardLayout },
    activeEmployerInfo,
    // Against a local 3-API (http://localhost:3001) instead of the deployed one:
    // isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
